// Campus photo for /colleges/bowdoin-college: Public domain, by Daderot, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMassachusetts_Hall_-_Bowdoin_College_-_IMG_7822.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/bowdoin-college/; credited under the photo.
const photo = {
    "slug": "bowdoin-college",
    "alt": "Massachusetts Hall, the oldest building at Bowdoin College in Brunswick, Maine",
    "src": "/colleges/bowdoin-college/campus-1600.webp",
    "srcSmall": "/colleges/bowdoin-college/campus-800.webp",
    "srcMid": "/colleges/bowdoin-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/bowdoin-college/og.jpg",
    "title": "Massachusetts Hall - Bowdoin College - IMG 7822",
    "author": "Daderot",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMassachusetts_Hall_-_Bowdoin_College_-_IMG_7822.JPG",
    "read": "2026-10-01"
};

export default photo;
